var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{attrs:{"color":"primary","active":"","disabled":!_vm.temPermissaoEdicao},on:{"click":_vm.novoDocumento}},[_c('v-icon',{attrs:{"small":""}},[_vm._v("add_circle")]),_vm._v("\n    Adicionar\n")],1)}
var staticRenderFns = []

export { render, staticRenderFns }